import React from 'react';

import type { Extension } from '../../web-client';
import { isDeveloperSpaceError } from './errorTypes';
import { ForgeDeprecationMessage } from './ForgeDeprecationMessage';
import { ForgeDevSpaceErrorMessage } from './ForgeDevSpaceErrorMessage';

interface ForgeAppErrorMessageProps {
	error: string;
	extension: Extension;
}

/**
 * Single source of truth for Forge app error UI, rendered into the runtime
 * overlay slot (see `useRuntimeErrorOverlay`). The dev-space message uses `useIntl`, so
 * it must render under an ancestor `IntlProvider` — in the runtime overlay it inherits
 * the host's (which carries the locale + message catalog), like `ThreeLOPrompt`.
 */
export const ForgeAppErrorMessage = (props: ForgeAppErrorMessageProps): React.JSX.Element => {
	const { error, extension } = props;

	if (isDeveloperSpaceError(error ?? '')) {
		return <ForgeDevSpaceErrorMessage />;
	}

	return <ForgeDeprecationMessage error={error ?? ''} extension={extension} />;
};
